import type { GetTweetById200ReferencedTweetTweet } from './getTweetById200ReferencedTweetTweet';
import type { GetTweetById200ReferencedTweetType } from './getTweetById200ReferencedTweetType';

/**
 * 참조된 트윗 정보 (답글, 인용, 리트윗인 경우)
 */
export type GetTweetById200ReferencedTweet = {
  /** 참조된 트윗 ID */
  id?: string;
  /** 참조된 트윗 요약 정보 (순환 참조 방지) */
  tweet?: GetTweetById200ReferencedTweetTweet;
  type?: GetTweetById200ReferencedTweetType;
};
